import React, { useState, useEffect } from 'react';
import GridLayout from './layout/GridLayout';
import WidgetListContainer from './layout/WidgetListContainer';
import { TbPower } from "react-icons/tb";
import { BsGrid1X2Fill } from "react-icons/bs";
import { BsGrid1X2 } from "react-icons/bs";
import { GoDotFill } from "react-icons/go";
import { FiSave } from "react-icons/fi";

import Sockets from '../utils/Sockets';
import useGridStore from '../stores/GridStore';

import useUserStore from '../stores/UserStore';
import useTradeStore from '../stores/TradesStore';
import useAlgoStore from '../stores/AlgosStore';
import useTriggerStore from '../stores/TriggersStore';
import useExchangeStore from '../stores/ExchangesStore';
import useArbStore from '../stores/ArbsStore';
import useConsoleStore from "../stores/ConsoleStore";
import useSettingsStore from "../stores/SettingsStore";
import useUserSettingStore from '../stores/UserSettingsStore';
import useToolsStore from '../stores/ToolsStore';
import usePositionsStore from '../stores/PositionsStore';
import usePortfolioStore from '../stores/PortfolioStore';

function GridContainer() {
  const [showSaveBtn, setShowSaveBtn] = useState(false);
  const [tooltip, setTooltip] = useState({ show: false, x: 0, y: 0, text: '' });
  const { tabs, activeTabId, setActiveTab, addTab, removeTab, renameTab, resetToDefaultLayout, saveLayout, loadLayout,  resetTabletDefault, resetTabletPortraitDefault} = useGridStore();
  const [newTabName, setNewTabName] = useState('');
  const { logOut } = useUserStore();
  const { fetchTrades } = useTradeStore();
  const { fetchAlgos } = useAlgoStore();
  const { fetchPositions } = usePositionsStore()
  const { fetchTriggers } = useTriggerStore();
  const { fetchExchanges, exchanges_list } = useExchangeStore();
  const { fetchArb } = useArbStore();
  const { fetchConsole } = useConsoleStore();
  const { fetchSettings, settings } = useSettingsStore();
  const { fetchUserSettings, userTargets } = useUserSettingStore();
  const {isMobile, isTablet, isPortrait} = useToolsStore()
  // const {fetchGlobalPortfolio, fetchPairsPortfolio, fetchshortLongPortfolio, fetchExchangesPortfolio} = usePortfolioStore()
  useEffect(() => {

    const fetchData = async () => {
      try {
        console.log('FETCHING  normal')
        await fetchTrades();
        await fetchAlgos();
        await fetchTriggers();
        await fetchPositions();
        
        // await fetchArb();
        await fetchConsole();
        await fetchSettings();
        await fetchExchanges();
        // await fetchUserSettings();
        // await fetchGlobalPortfolio();
        // await fetchshortLongPortfolio();
        // await fetchPairsPortfolio();
        // await fetchExchangesPortfolio();
        console.log('SERINNNGS', settings)
        
      } catch (error) {
        if (error.response && error.response.status === 401) {
          logOut();
        } else {
          console.log("Error fetching data", error);
        }
      }
    };

    fetchData();
  }, []);

  const handleMouseEnter = (e, text) => {
    setTooltip({ show: true, x: e.clientX, y: e.clientY, text });
  };

  const handleMouseLeave = () => {
    setTooltip({ show: false, x: 0, y: 0, text: '' });
  };

  const showSaveLayoutBtn = () => {
    setShowSaveBtn(prevState => !prevState);
  };

  const saveThisLayout = (layout) => {
    saveLayout(layout);
  };

  const loadThisLayout = (layout) => {
    loadLayout(layout);
  };
  const setDefault = () => {
    if (!isTablet && !isPortrait && !isMobile) {
      console.log('RESET DEFAULT')
      resetToDefaultLayout()
    }
    if (isTablet) {
      resetTabletDefault()
      console.log('LEFT TABLET')
    }
    if (isPortrait) {
      resetTabletPortraitDefault()
      console.log('LEFT PORTRAIT')
    }
   
  }

  return (
    <div className='app_container'>
      <div className="app_hero"></div>
      <Sockets />
      <div className="left_container no_drag">
        <WidgetListContainer />

        <div className="save_layouts_container" id="layout_1" onClick={() => showSaveLayoutBtn()}>
          <FiSave className='no_drag save_layout_icon' />
          <div id='save_layout_btn_container' className={showSaveBtn ? "save_dropdown_container show no_drag" : "save_dropdown_container hide no_drag"}>
            <button className="save_layout_button btn" onClick={() => saveThisLayout('layout_3')}>Layout 3</button>
            <button className="save_layout_button btn" onClick={() => saveThisLayout('layout_2')}>Layout 2</button>
            <button className="save_layout_button btn" onClick={() => saveThisLayout('layout_1')}>Layout 1</button>
          </div>
        </div>

        <div className="layouts_container">
          <div
            className="layout_container no_drag border_b"
            id="layout_1"
            onClick={() => loadThisLayout('layout_1')}
            onMouseEnter={(e) => handleMouseEnter(e, "Layout 1")}
            onMouseLeave={handleMouseLeave}
          >
            <GoDotFill className='dot_icon one no_drag' />
          </div>
          <div
            className="layout_container no_drag border_lb"
            id="layout_2"
            onClick={() => loadThisLayout('layout_2')}
            onMouseEnter={(e) => handleMouseEnter(e, "Layout 2")}
            onMouseLeave={handleMouseLeave}
          >
            <GoDotFill className='dot_icon two_one no_drag' />
            <GoDotFill className='dot_icon two_two no_drag' />
          </div>
          <div
            className="layout_container no_drag"
            id="layout_3"
            onClick={() => loadThisLayout('layout_3')}
            onMouseEnter={(e) => handleMouseEnter(e, "Layout 3")}
            onMouseLeave={handleMouseLeave}
          >
            <GoDotFill className='dot_icon three_one no_drag' />
            <GoDotFill className='dot_icon three_two no_drag' />
            <GoDotFill className='dot_icon three_three no_drag' />
          </div>
          <div
            className="layout_container no_drag border_l"
            id="reset_default_btn"
            onClick={() => setDefault()}
            onMouseEnter={(e) => handleMouseEnter(e, "Default layout")}
            onMouseLeave={handleMouseLeave}
          >
            <BsGrid1X2 className='layout_icon no_drag' />
          </div>
        </div>
        <Tooltip tooltip={tooltip} />
        <button className="power_button no_drag" onClick={() => logOut()} id='logout_btn'>
          <TbPower
            className='power_icon no_drag'
            id='logout_btn'
            onMouseEnter={(e) => handleMouseEnter(e, "Logout")}
            onMouseLeave={handleMouseLeave}
          />
        </button>
      </div>
      {/* <div className="tab_container">
        {tabs.map(tab => (
          <div key={tab.id} onClick={() => setActiveTab(tab.id)} className={`tab ${tab.id === activeTabId ? 'active_tab' : ''}`}>
        
            <div className="tab_name" ><p>{tab.name}</p></div>
            {tab.name === "Main" ? <button className="btn select_tab" onClick={() => setActiveTab(tab.id)}>"</button>
              : <>

                <button className="btn close_tab" onClick={() => removeTab(tab.id)}>X</button>
              </>
            }

          </div>
        ))}
        <div className="add_tab_container">
          <input className='input add_tab_input' type="text" placeholder="MyTab" value={newTabName} onChange={(e) => setNewTabName(e.target.value)} />
          <button className="add_tab_btn btn" onClick={() => { addTab(newTabName || `Tab ${tabs.length + 1}`); setNewTabName(''); }}>
            +
          </button>
        </div>
      </div> */}
      <div className="grid_layout_container">
        <GridLayout />
      </div>
    </div>
  );
}

const Tooltip = ({ tooltip }) => {
  if (!tooltip.show) return null;

  const tooltipStyle = {
    position: 'fixed',
    top: tooltip.y - 10,
    left: tooltip.x + 30,
    backgroundColor: 'black',
    color: 'white',
    padding: '5px 10px',
    borderRadius: '5px',
    pointerEvents: 'none',
    transform: 'translate(-50%, -100%)',
    zIndex: 1000,
    fontSize: "0.8rem",
    opacity: 0.8,
    whiteSpace: "nowrap",
  };

  return <div style={tooltipStyle}>{tooltip.text}</div>;
};

export default GridContainer;
